import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import {
  average,
  max,
  min,
  quantile,
  standardDeviation,
} from "simple-statistics";
import { formatter, getDateFormat2 } from "../../../helpers/helper";
import { Patient } from "../../../models/Patient";
import {
  deleteRecord,
  getRecordDetail,
  patchRecord,
} from "../../../services/httpService/recordRequest";
import { GlobalContext } from "../../contexts/globalContext";


const statistics = [
  { label: "Count" },
  { label: "Average", cb: average },
  { label: "Standard Deviation", cb: standardDeviation },
  { label: "Minimum", cb: min },
  { label: "25%", cb: (data) => quantile(data, 0.25) },
  { label: "50%", cb: (data) => quantile(data, 0.5) },
  { label: "75%", cb: (data) => quantile(data, 0.75) },
  { label: "Maximum", cb: max },
];

const Print = () => {
  const isMounted = useRef(true);
  const params = useParams();
  const history = useHistory();
  const [record, setRecord] = useState("");


  useEffect(() => {
   
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
     <iframe style={{width: '100%', height: '100%'}} src={`${process.env.REACT_APP_PRINTING}/?id=` + params.id + "&idKey=" + JSON.parse(sessionStorage.getItem("respinosApp")).token }></iframe>
     {/* <iframe style={{width: '100%', height: '100%'}} src={`http://localhost:55195/?id=` + params.id + "&idKey=" + JSON.parse(sessionStorage.getItem("respinosApp")).token }></iframe> */}
    </>
  );
};

export default Print;
